import {useHistory, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import Loader from "../../../ui_library/ver_24.10/Loader/Loader.comp";
import DQRatingPaymentView from "../../../views/ver_24.10/ProgramRating/DQRating/DQRatingPayment.view";

import {
    getApplicationService as fetchRatingProgramService,
    getApplicationDataService as getRatingProgramDataService,
    getAppPaymentService as getRatingProgramPaymentService,
    updateApplicationDataService as updateRatingProgramDataService,
    updateStripeIntentService
} from "../../../services/app.service";
import {APP_STATUS, PAYMENT_STATUS} from "../../../utils/constants";
import {applyPromoCodeService, updateCompanyInfoService} from "../../../services/rating.service";
import {getCompanyInfoService} from "../../../services/company.service";

const DQRatingPaymentPage = () => {
    const history = useHistory();
    const { programId } = useParams();

    const [showLoader, setShowLoader] = useState(false);
    const [appData, setAppData] = useState({});
    const [paymentAmount, setPaymentAmount] = useState("");
    const [payment, setPayment] = useState(undefined);
    const [initialAmount, setInitialAmount] = useState(undefined);
    const [paymentFetched, setPaymentFetched] = useState(false);
    const [openDialogue, setOpenDialogue] = useState(false);
    const [isBillingSaved, setIsBillingSaved] = useState(false);
    const [programStatus, setProgramStatus] = useState(null);
    const [paymentStatusV3, setPaymentStatusV3] = useState(null);
    const [ratingType, setRatingType] = useState(null);
    const [appliedPromoCode, setAppliedPromoCode] = useState(null);
    const [companyInfo, setCompanyInfo] = useState({});
    const loadAppData = async () => {
        try {
            setShowLoader(true);
            const result = await getRatingProgramDataService(programId);
            if (!result.error) {
                if (result.data.app_data) {
                    setAppData(result.data.app_data);
                }
                setShowLoader(false);
            }

        } catch (e) {
            // already toasted the error
            setShowLoader(false);
        }
    }

    async function retrieveApplication() {
        try {
            setShowLoader(true);
            const result = await fetchRatingProgramService(programId);
            if(!result.error && result.data) {
                const {amount, initial_amount, app_status_v3, payment_status_v3, rating_type} = result.data;
                setPaymentAmount(amount.toString());
                setInitialAmount(initial_amount.toString());
                setProgramStatus(app_status_v3);
                setPaymentStatusV3(payment_status_v3);
                setRatingType(rating_type);
                if (
                    result.data.app_status_v3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED
                ) {
                    history.push(`/dq_rating/${programId}`);
                }
                setShowLoader(false);
            }
        }
        catch (e) {
            console.error(e)
            setShowLoader(false);
        }
    }

    const getCompanyInfo = async () => {
        try {
            setShowLoader(true);
            const result = await getCompanyInfoService();
            console.log("Company Info Service API: ", result.data.comp);

            if (!result.error && result.data) {
                if (result.data.comp) {
                    setCompanyInfo({
                        NameOrg: result.data.comp.name_org,
                        Region: result.data.comp.region,
                        // sameAsOrgInfo: true,
                        nameCompany: result.data.comp.billing_info && result.data.comp.billing_info.name_org ? result.data.comp.billing_info.name_org : '',
                        addressCompany: result.data.comp.billing_info && result.data.comp.billing_info.address_org ? result.data.comp.billing_info.address_org : '',
                        contactCompany: result.data.comp.billing_info && result.data.comp.billing_info.contact_no_org ? result.data.comp.billing_info.contact_no_org : '',
                        nameContactPerson: result.data.comp.billing_info && result.data.comp.billing_info.name_contact ? result.data.comp.billing_info.name_contact : '',
                        emailContactPerson: result.data.comp.billing_info && result.data.comp.billing_info.email_contact ? result.data.comp.billing_info.email_contact : '',
                        contactContactPerson: result.data.comp.billing_info && result.data.comp.billing_info.contact_no_contact ? result.data.comp.billing_info.contact_no_contact : '',
                    });
                    console.log("companyInfo: ", companyInfo);
                }
            }
        } catch (e) {
            // already toasted the error
            setShowLoader(false);
        } finally {
            setShowLoader(false);
        }
    }


    useEffect(() => {
        loadAppData().then((res) => `fetch initiated, ${res}`);
        retrieveApplication().then();
        getCompanyInfo().then((res) => `billing info fetch initiated, ${res}`);
    }, [])



    async function loadPayment() {
        const result = await getRatingProgramPaymentService(programId);
        if(result.data) {
            const {payment} = result.data;
            setPayment(payment);
            setPaymentFetched(true);
        }
        return true;
    }

    async function updateStripePayment(paymentIntent) {
        const result = await updateStripeIntentService(programId, paymentIntent);
        if(result.data) {
            const {payment} = result.data;
            if(payment.status === PAYMENT_STATUS.SUCCESSFUL) {
                console.log("Payment status", payment.status);
            }
            setPayment(payment)
            setPaymentFetched(true);
        }
        return true;
    }

    function removeUrlParameter(paramKey) {
        const url = window.location.href

        const r = new URL(url)
        r.searchParams.delete(paramKey)
        const newUrl = r.href
        window.history.pushState({ path: newUrl }, '', newUrl)
    }

    useEffect( () => {
        const paymentIntent = new URLSearchParams(window.location.search).get("payment_intent");
        if(paymentIntent) {
            updateStripePayment(paymentIntent).then(() => console.log(`stripe payment updated`)).catch((e) => console.error(`stripe payment update failed, ${e}`))
        } else {
            loadPayment().then(() => console.log(`app payment fetched`)).catch((e) => console.error(`app payment fetch failed, ${e}`))
        }
        removeUrlParameter('payment_intent');
        removeUrlParameter('payment_intent_client_secret')
    }, [])

    useEffect(() => {
        const redirectStatus = new URLSearchParams(window.location.search).get("redirect_status");
        if(redirectStatus) {
            switch (redirectStatus) {
                case "succeeded":
                    console.log("Payment", "Payment successful");
                    break;
                case "processing":
                    console.log("Payment", "Payment is in processing");
                    break;
                case "requires_payment_method":
                    console.log("Payment", "Payment was not successful, try again");
                    break;
                default:
                    console.log("Payment", "Something went wrong");
                    break;
            }
        }
        removeUrlParameter('redirect_status');
    }, [])


    const data = {
        'application_id': programId,
        openDialogue,
        appData,
        payment,
        paymentAmount,
        initialAmount,
        paymentStatusV3,
        ratingType,
        paymentFetched,
        isBillingSaved,
        companyInfo,
        appliedPromoCode
    };

    const actions = {
        billingInfoSaveAction : async (values) => {
            try {
                // setShowLoader(true);
                const result = await updateCompanyInfoService(values);
                if (!result.error) {
                    console.log('result.data -> ', result.data);
                    setIsBillingSaved(true);
                    // setShowLoader(false);
                }
            } catch (e) {
                // already toasted the error
                // setShowLoader(false);
            } finally {
                // setShowLoader(false);
            }
        },
        applyPromoCodeAction : async (programId, promo_code) => {
            try {
                setShowLoader(true);
                const result = await applyPromoCodeService(programId, promo_code);
                if (!result.error && result.data) {

                    const {amount, initial_amount, app_status_v3, payment_status_v3} = result.data.program_application;
                    setPaymentAmount(amount.toString());
                    setInitialAmount(initial_amount.toString());
                    setProgramStatus(app_status_v3);
                    setPaymentStatusV3(payment_status_v3);
                    setAppliedPromoCode(promo_code);
                    console.log('result.data -> ', result.data);
                }
            } catch (e) {
                // already toasted the error
                setShowLoader(false);
            } finally {
                setShowLoader(false);
            }
        },
        showPdfReportAction: async () => {
            if (programStatus >= APP_STATUS.COMPLETED) {
                history.push(`/dq_rating/${programId}/full_report`);
            } else {
                history.push(`/dq_rating/${programId}`);
            }
        },
        addFilePathToApplicationDataAction : async (file_path) => {
            try {
                setShowLoader(true);
                const result = await updateRatingProgramDataService(programId, file_path);
                if(!result.error) {
                    console.log("Uploaded", "Successfully uploaded the proof, once it's verified you will be able to access next steps.")
                    if (result.data.app_data) {
                        setAppData(result.data.app_data);
                    }
                }
                setShowLoader(false);
                setOpenDialogue(false);
            }
            catch (e) {
                //already toasted
                setOpenDialogue(false);
                setShowLoader(false);
            }
        }

    };

    const options = {
        setOpenDialogue : (openDialogue) => {openDialogue ? setOpenDialogue(openDialogue) : setOpenDialogue(false);},
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <DQRatingPaymentView data={data} actions={actions} options={options} />
        </>
    );
};

export default DQRatingPaymentPage;